import { ReactNode, Provider, ReactElement, Suspense } from 'react';
import { AuthComponent } from './AuthComponent';
import { LoadingScreen } from 'app/agriculture/components/LoadingScreen';

export const LOCAL_STORAGE_TOKEN_KEY = 'ls.currentApiToken';

export function TokenContextProvider({
    children,
}: {
    children: ReactNode;
}): ReactElement<Provider<string>> {
    return (
        <Suspense fallback={<LoadingScreen />}>
            <AuthComponent>{children}</AuthComponent>
        </Suspense>
    );
}
